<!-- 処分業者詳細 -->
<template>
  <v-container>
    <v-breadcrumbs
      class="px-0 py-2"
      :items="breadcrumbs"
    />
    <v-card>
      <v-card-title>処分業者詳細</v-card-title>
        
      <v-card
        class="mx-auto"
        max-width="800"
      >
        <v-card-text>
          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-content class="text-h5">
                {{ disposer.name }}
              </v-list-item-content>
              <v-list-item-subtitle> {{ disposer.subscriber_number }} </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-map-marker</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <div v-if="disposer.zip_code">〒{{ disposer.zip_code }}</div>
              {{ disposer.address }}
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-phone</v-icon>
            </v-list-item-icon>
            <v-list-item-content>{{ disposer.phone_number }}</v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-icon>
              <v-icon>mdi-fax</v-icon>
            </v-list-item-icon>
            <v-list-item-content>{{ disposer.fax_number }}</v-list-item-content>
          </v-list-item>
        </v-card-text>
      </v-card>

      <v-card-text>
        <v-data-table
          :headers="tableHeaders"
          :items="disposer.locations"
          disable-sort
          hide-default-footer
        >
          <template v-slot:[`item.location_name`]="{ item }">
            <span :title="item.location_name">{{ item.location_name | truncate(15) }}</span>
          </template>
          <template v-slot:[`item.address`]="{ item }">
            <span :title="item.address">
              {{ item.address | truncate(20) }}
            </span>
          </template>
        </v-data-table>
      </v-card-text>

      <v-card-text>
        <v-data-table
          :headers="tenantTableHeaders"
          :items="disposer.tenants"
          disable-sort
          hide-default-footer
        >
          <template v-slot:[`item.name`]="{ item }">
            <span :title="item.name">{{ item.name | truncate(15) }}</span>
          </template>
          <template v-slot:[`item.created_at`]="{ item }">
            <span v-if="item.deleted" style="color:#FF0000">
              ●
            </span>
            {{ item.created_at | unix_datetime_format }}
          </template>
        </v-data-table>
        <v-row>
          <v-col cols="3">
            <v-checkbox
              v-model="disposer.not_possible_manifest"
              dense
              label="マニフェスト起票不可"
              hide-details="auto"
            />
          </v-col>
          <v-col cols="3">
            <v-checkbox
              v-model="disposer.use_jwnet"
              dense
              label="JWNET対象"
              hide-details="auto"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-btn
          :disabled="disposer.use_jwnet"
          color="error"
          @click="deleteButtonClickEvent"
        >
          削除
        </v-btn>
        <v-spacer />
        <v-btn
          color="primary"
          @click="showButtonClickEvent(disposer)"
        >
          ルート確認
        </v-btn>
        <v-btn
          color="primary"
          @click="registerButtonClickEvent"
        >
          保存
        </v-btn>
      </v-card-actions>
    </v-card>
    <confirm ref="confirm" />
    <!-- /ダイアログ -->
    <transport-routes-show-dialog
      :enable-dialog="enableRoutesDialog"
      :target-id="targetId"
      @closeEvent="closeRoutesDialog"
      @registerEvent="routesCallback"
    />
    <!-- ダイアログ -->
  </v-container>
</template>

<script>
import { mapActions} from 'vuex'
import Confirm from '../../../../components/Confirm'
import TransportRoutesShowDialog from '../dialogs/TransportRoutesShowDialog'
export default {
  name: 'AdminMasterDisposerShow',
  components: {Confirm,TransportRoutesShowDialog},
  filters: {},
  mixins: [],
  props: {},
  data() {
    return {
      enableRoutesDialog: false,
      targetId: null,
      breadcrumbs: [
        { text: '処分業者一覧', disabled: false, to: '/admin/masters/disposers', exact: true },
        { text: '処分業者詳細', disabled: true, to: '' },
      ],
      tableHeaders: [
        { value: 'location_code', text: '事業場コード' },
        { value: 'location_name', text: '事業場名称' },
        { value: 'location_type_name', text: '事業者区分' },
        { value: 'zip_code', text: '郵便番号' },
        { value: 'address', text: '所在地' },
        { value: 'phone_number', text: '電話番号' },
        { text: '', value: 'editable', align: 'end' },
      ],
      tenantTableHeaders: [
        { value: 'code', text: 'テナントコード' },
        { value: 'name', text: 'テナント名' },
        { value: 'supervisor_name', text: '担当者名' },
        { value: 'phone_number', text: '電話番号' },
        { value: 'created_at', text: '登録日時' },
      ],
      disposer: {}
    }
  },
  computed: {},
  watch: {},
  created() {
    this.fetchDisposer({ id: this.$route.params.id }).then((content) => {
      this.disposer = content
    })
  },
  methods: {
     ...mapActions('AdminMasterDisposer', {
      fetchDisposer: 'show',
      updateDisposer: 'update',
      deleteDisposer: 'destroy',
    }),
    showButtonClickEvent (item) {
      this.targetId = item.id
      this.enableRoutesDialog = true
    },
    closeRoutesDialog () {
      this.enableRoutesDialog = false;
    },
    routesCallback (forms) {
      this.closeRoutesDialog()
    },
    registerButtonClickEvent () {
      let params = {
        not_possible_manifest: this.disposer.not_possible_manifest,
        use_jwnet: this.disposer.use_jwnet
      }
      if (this.disposer.use_jwnet === false) {
        let modalOption = {
          title: "更新",
          message: "JWNET対象をONからOFF変更している場合に全てのルートが非表示設定されます。よろしいですか",
          options: { width: 450, titleColor: "red", isCancelButton: true },
        }
        this.$refs.confirm.open(modalOption).then((confirm) => {
          this.$refs.confirm.close()
          if (confirm) {
            this.updateDisposer({ id: this.disposer.id, params: params }).then(() => {
              this.$router.push( { name: 'AdminMasterDisposers' } )
            })
          }
        })
      } else {
        this.updateDisposer({ id: this.disposer.id, params: params }).then(() => {
          this.$router.push( { name: 'AdminMasterDisposers' } )
        })
      }
    },
    deleteButtonClickEvent () {
      this.$refs.confirm.showDeleteConfirm().then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.deleteDisposer({id: this.$route.params.id }).then(() =>{
            this.$router.push({name: 'AdminMasterDisposers'})
          })
        }
      })
    },
  }
}
</script>

<style scoped>

</style>
